// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_PublicPacksResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for the A3 franqueado-facing active-only pack catalog.
 *
 * Reuses AiCredits_PackRow rows (same shape as the staff CRUD list).
 * Shape: { rows: AiCredits_PackRow[], purchase_enabled: bool }.
 *
 * purchase_enabled (OD-016): true when the ai_credit_topup feature is enabled
 * for at least one registered gateway that declares one_off_charge capability.
 * Computed server-side so the CTA can gate without a second round-trip.
 */
import type { AiCredits_PackRow } from './AiCredits_PackRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_PublicPacksResponseDados {
rows: AiCredits_PackRow[]
purchase_enabled: boolean
empty_reason: string
}

export type AiCredits_PublicPacksResponse = ApiResponse<AiCredits_PublicPacksResponseDados>;

registerResponseContract('AiCredits_PublicPacksResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:               { type: 'number',  required: true },
      name:             { type: 'string',  required: true },
      credits:          { type: 'number',  required: true },
      price_cents:      { type: 'number',  required: false },
      currency:         { type: 'string',  required: false },
      provider_code:    { type: 'string',  required: false },
      countries:        { type: 'array',   required: false },
      active:           { type: 'number',  required: true },
      sort_order:       { type: 'number',  required: true },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
      purchase_enabled: { type: 'boolean', required: false },
    },
  },
  purchase_enabled: { type: 'boolean', required: true },
  empty_reason:     { type: 'string',  required: false },
})
